@let readOnly = $readOnly();

<form [formGroup]="formGroup">
  <div class="x-card x-card_size_m x-white card-shadow">
    <p class="x-island-header">
      {{ 'request_form.common.logists.title' | translate }}
    </p>

    <div class="x-input-label">
      {{ 'request_form.common.logists.logist_fullname' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.OwnerLogistFullname"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.logists.logist_phone_number' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.OwnerLogistPhone"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.logists.leasing_product' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.LeasingProduct"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.logists.extended_program' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.ExtendedProgram"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>
  </div>
</form>
